import { createFileRoute, Outlet } from "@tanstack/react-router"

export const Route = createFileRoute("/app/resources/resource-objects")({
  component: Outlet,
  beforeLoad: ({ context: { t } }) => ({
    getTitle: () => t && t("Resources_Title"),
  }),
})
